export default __webpack_public_path__ + "static/media/Schwein-vor-Hütte.d3e8dbe4.png";